
import { Component, Vue } from 'vue-property-decorator';
import type { DynamicField } from '@/models/dynamicField';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import type { AppliedLesson } from '@/models/appliedlesson';
import { Getter } from 'vuex-class';
import type { CompanySetting } from '@/models/companySetting';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import { ExportField } from '@/components/export/ExportField';

@Component({
    name: 'Export',
    components: {},
})
export default class Export extends Vue {
    protected static boolAttributes = {
        width: '7%',
        align: 'center',
    };

    // protected fields: Array<ExportField>;

    @Getter('account/companySetting') protected companySetting: CompanySetting;

    sortDynamicField(lessons: AppliedLesson[] | PMAppliedLesson[] | XAppliedLesson[], fields: any[]) {
        const dynamic_field = fields.find((field) => field.field === 'dynamic_field');
        if (dynamic_field && this.companySetting.feature_dynamic_worksheet_field) {
            return lessons
                .sort(
                    (
                        a: AppliedLesson | PMAppliedLesson | XAppliedLesson,
                        b: AppliedLesson | PMAppliedLesson | XAppliedLesson
                    ) => {
                        if (a.dynamic_field !== null && b.dynamic_field === null) {
                            return -1;
                        } else if (a.dynamic_field === null && b.dynamic_field !== null) {
                            return 1;
                        } else if (a.dynamic_field === null && b.dynamic_field === null) {
                            return 0;
                        }
                        if (a.dynamic_field && b.dynamic_field) {
                            if (a.dynamic_field.order === b.dynamic_field.order) {
                                return 0;
                            }
                            return a.dynamic_field.order < b.dynamic_field.order ? -1 : 1;
                        }
                        return 0;
                    }
                )
                .reverse();
        } else {
            return lessons;
        }
    }

    translatedFields(fields: ExportField[] = [], data = {}) {
        return fields.map((field) => {
            if (field.header) {
                return field.header(data);
            }

            const translationKey = 'print.' + field.field;

            return this.$te(translationKey) ? (this.$t(translationKey) as string) : field;
        });
    }

    parseQueryFields(fields: any[]) {
        fields.forEach((field) => {
            field.enabled = field.default ? field.default : false;
        });

        // Hide "done" if filterResolved is set to not_resolved
        fields.forEach((field) => {
            if (field.field === 'done') {
                field.enabled = this.$route.query.filterResolved !== 'not_resolved';
            }
        });

        console.log(this.$route.query);

        if (this.$route.query.fields) {
            this.$route.query.fields
                .toString()
                .split(',')
                .forEach((field) => {
                    const target = fields.find((f) => f.field === field);

                    if (target) {
                        target.enabled = true;
                    }
                });
        }
    }

    renderDynamicField(dynamicField: DynamicField) {
        const titleWithImpact = this.companySetting.feature_dynamic_worksheet_field_impact
            ? `${dynamicField.title} (${dynamicField.value})`
            : dynamicField.title;

        return dynamicField.color !== null
            ? `<div class="export-dynamic-field" style="background-color: ${dynamicField.color}">${titleWithImpact}</div>`
            : titleWithImpact;
    }

    activeFields(fields: any[]) {
        return fields.filter((field) => field.enabled);
    }

    columnStyles(fields: any[]) {
        return fields
            .filter((field) => field.enabled)
            .map((field) => {
                return [
                    field.width ? 'min-width: ' + field.width : null,
                    field.width ? 'width: ' + field.width : null,
                    field.align ? 'text-align: ' + field.align : null,
                    field.display === false ? 'visibility: hidden' : 'visibility: visible',
                    field.render !== undefined && !field.render ? 'display:none' : '',
                ].join(';');
            });
    }
}
